<template>
	<div>
		<div class="d-flex align-center justify-end mb-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_crms_count"
				:loading-info="$store.state.crm.loadingConversations"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_crms"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_crms_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
			<template v-slot:item.id="{ item }">
				<div>
					<div class="d-flex align-center">
						<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project_line_info?.project_line?.number }}</p>
						<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
					</div>
					<div class="d-flex align-center">
						<ProjectLineAssociationIcons :projectLineAssociations="item.associations" />
					</div>
				</div>
			</template>
      <template v-slot:item.date="{ item }">
				<p class="mb-0 caption">{{ item.created_at | toDateTime }}</p>
      </template>
      <template v-slot:item.unarchive="{ item }">
				<div v-if="item.report_budgets?.length">
					<v-btn
						text
						dark
						x-small
						color="black"
						class="mb-1"
						@click.stop="() => { selectRow(item); openReportDetail && openReportDetail(getLastReportBudget(item).id); }"
					>
						<div class="d-flex align-center justify-center">
							<p class="font-weight-bold mb-0">{{getLastReportBudgetSerial(item)}}</p>
							<v-icon class="ml-1" x-small color="warning">mdi-eye</v-icon>
						</div>
					</v-btn>

					<div class="d-flex justify-center align-center">
						<div>
							<v-chip
								:color="reportStatusColor(item)"
								label
								outlined
								x-small
								class="px-1 py-2"
							>
								<div class="d-flex align-center justify-space-between caption">
									<b>{{reportStatusText(item)}}</b>
								</div>
							</v-chip>
							<p class="mb-0 caption" v-if="getLastReportBudget(item)?.budget?.payment_order"><small>Fecha Pago: </small><b>{{ getLastReportBudget(item)?.budget?.payment_order?.payment_info?.payment_date | toDate }}</b></p>
						</div>
					</div>
				</div>
				<div v-else>--</div>
			</template>
      <template v-slot:item.project="{ item }">
				<p class="mb-0 caption font-weight-bold">{{ item.project_info?.project_detail }}</p>
				<p class="mb-0 caption" v-if="item.project_info?.address?.address">{{ item.project_info?.address?.address}}</p>
				<p class="mb-0 caption" v-else>--</p>
      </template>
      <template v-slot:item.vt_date="{ item }">
				<p class="mb-0 caption" v-if="item.schedule?.vt_date">{{ item.schedule?.vt_date | toDateTime }}</p>
				<p class="mb-0 caption" v-else>--</p>
      </template>
      <template v-slot:item.responsible="{ item }">
				<p class="mb-0 caption">{{ item.schedule?.user_schedule?.responsible?.profile?.name }} {{ item.schedule?.user_schedule?.responsible?.profile?.lastname }} {{ item.schedule?.user_schedule?.responsible?.profile?.second_lastname }}</p>
      </template>
      <template v-slot:item.status="{ item }">
				<v-chip
					class="mt-1"
					:color="vtStatus(item).color"
					x-small
					label
					dark
					v-if="vtStatus(item)"
				>
					<v-icon class="mr-1" x-small>mdi-email-outline</v-icon>
					{{vtStatus(item).text}}
				</v-chip>
      </template>

			<template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="primary"
							@click.stop="() => { selectRow(item); openCrmDetail(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-eye</v-icon>
						</v-btn>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							:dark="!(sentEmailDiff(item) != -1 && sentEmailDiff(item) < 24)"
							x-small
							color="secondary"
							:disabled="sentEmailDiff(item) != -1 && sentEmailDiff(item) < 24"
							v-if="item.schedule"
							@click.stop="() => { selectRow(item); resendPaymentRequest(item); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-email</v-icon>
						</v-btn>
					</template>
					<span>Enviar Correo Solicitud de Pago</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="#524D4D"
							v-if="item.schedule"
							@click.stop="() => { selectRow(item); openBudgetModal(item); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-table-cog</v-icon>
						</v-btn>
					</template>
					<span>Gestionar Presupuesto</span>
				</v-tooltip>
				<v-tooltip bottom v-if="canReplicate(item)">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#524D4D"
							class="mx-1"
							v-bind="attrs"
							v-on="on"
							v-if="$checkPermissions(['edit_crm'])"
							@click.stop="() => { selectRow(item); replicateContactModal(item); }"
						>
							<v-icon small dark>mdi-content-duplicate</v-icon>
						</v-btn>
					</template>
					<span>Replicar</span>
				</v-tooltip>
				<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="warning"
							class="mx-1"
							@click.stop="() => { selectRow(item); archiveCrm(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-archive-arrow-down-outline</v-icon>
						</v-btn>
					</template>
					<span>Archivar</span>
				</v-tooltip>
				<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="error"
							class="mx-1"
							@click.stop="() => { selectRow(item); startRemoveCrm(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-delete-outline</v-icon>
						</v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
				<!-- <v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#524D4D"
							class="mx-1"
							v-bind="attrs"
							v-on="on"
							@click.stop="() => { selectRow(item); toPreProjectsStart(item); }"
						>
							<v-icon small dark>mdi-send</v-icon>
						</v-btn>
					</template>
					<span>Crear Cliente</span>
				</v-tooltip> -->
			</template>
      <!-- <template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="primary"
							@click.stop="() => { selectRow(item); openCrmDetail(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-eye</v-icon>
						</v-btn>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#524D4D"
							class="mx-1"
							v-bind="attrs"
							v-on="on"
							@click.stop="() => { selectRow(item); toPreProjectsStart(item); }"
						>
							<v-icon small dark>mdi-send</v-icon>
						</v-btn>
					</template>
					<span>Crear Cliente</span>
				</v-tooltip>
      </template> -->
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_crms_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {sendScheduleEmail} from '@/helpers/api/conversations'
import {deleteCrmEntry, archiveCrmEntry} from '@/helpers/api/crm'
import {createBudget} from '@/helpers/api/budgets'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientsCrmList',
	components: {
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons,
		DataTablePagination
	},
	props: {
		openReportDetail: {
      type: Function,
      required: false
    },
		clientId: {
      type: Number,
      required: true
    },
		openCrmDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		loadingList() {
			return this.$store.state.crm.loadingClientCrm
		},
		client_crms() {
			return this.$store.state.crm.clientCrms
		},
		client_crms_count() {
			return this.$store.state.crm.clientCrmsCount
		},
		selected_crm() {
			return this.$route.query?.crm
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientCRM()
      },
      deep: true,
    }
	},
	data: () => ({
		selectedRowItem: null,
		headers: [
			{ text: 'Línea de Proyecto', value: 'id', align: 'center', sortable: false },
			{ text: 'Proyecto', value: 'project', sortable: false },
			{ text: 'Fecha de Creación', value: 'date', width: '120px', align: 'center', sortable: false },
			{ text: 'Visita Técnica', value: 'vt_date', width: '120px', align: 'center', sortable: false },
			{ text: 'P. Desarchivo', value: 'unarchive', width: '140px', align: 'center', sortable: false },
			{ text: 'Profesional Encargado', value: 'responsible', align: 'center', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', sortable: false },
			{ text: 'Acciones', value: 'actions', align: 'center', sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientCRM()
		const crm_id = this.$route.query.crm
		if(crm_id){
			this.selectedRowItem = crm_id
			this.openCrmDetail(crm_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_crm_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		eventBus.$on('reloadInformation', this._onReloadCrm)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this._onReloadCrm);
	},
	methods: {
		getLastReportBudgetSerial(item) {
			if (!item.report_budgets || item.report_budgets.length === 0) {
				return null;
			}
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];

			const serial = `${last.serial?.serial} - LP${item.project_line_info?.project_line?.number} - ${last.prefix?.prefix} ${last.report_index}`;

			return serial.trim();
		},
		startPaymentUnarchive(item){
			const last = this.getLastReportBudget(item)
			if(last && last.budget?.id){
				const url = 'https://apiarq.insomnia.cl/report-budget-confirm?rb=' + last.budget?.id;
				window.open(url, '_blank').focus();
			}
		},
		getLastReportBudget(item){
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			return last
		},
		reportStatusText(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatus(reportStatus)
		},
		reportStatusColor(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatusColor(reportStatus)
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_crm_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		_onReloadCrm(){
			this.getClientCRM()
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientCRM()
		},
		getRowClass(item) {
			return item.id == this.selected_crm ? 'custom-client-highlight-row' : '';
		},
		vtStatus(conversation){
			if(conversation.schedule && conversation.schedule.status == 2 && conversation.schedule.request_email.length > 0){
				return {
					text: 'Informe Enviado',
					color: 'success'
				}
			}
			else if(conversation.schedule){
				return {
					text: 'Informe Pendiente',
					color: 'warning'
				}
			}
			return null
		},
		async getClientCRM(){
			let data = {
				...this.options,
				client_id: this.clientId,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('crm/getClientCrms', data)
			// this.loadingList = true
			// try {
			// 	const client_crm = await getClientCRM({
			// 		client_id: this.clientId,
			// 		start: 1,
			// 		limit: 100
			// 	})
			// 	if(client_crm.code == 200){
			// 		this.client_crms = client_crm.client_crm
			// 	}
			// } catch (error) {
			// 	console.log(error)
			// }
			// this.loadingList = false
		},
		toPreProjectsStart(crm){
			const preproject_info = {
				crm_id: crm.id,
				client_id: crm.user.user_id,
				name: crm.project_info?.project_detail
			}
			localStorage.setItem('new_preproject_info', JSON.stringify(preproject_info));
			this.$store.commit('preprojects/setNewPreProjectModal', true)
		},
		async resendPaymentRequest(conversation){
			try {
				await sendScheduleEmail({schedule_id: conversation.schedule.id})
				const data = {
					message: 'El correo con la solicitud de pago ha sido enviado al usuario.',
					title: 'Correo enviado correctamente',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.getClientCRM()
			} catch {
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al enviar el correo',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		},
		sentEmailDiff(conversation){
			if(conversation.schedule && conversation.schedule.request_email.length > 0){
				const current = moment()
				const startTime = conversation.schedule.request_email[0].created_at
				var duration = moment.duration(current.diff(startTime))
				var hours = duration.asHours()
				return hours
			}
			else if(conversation.schedule.request_email.length == 0){
				return -1
			}
			return null
		},
		async openBudgetModal(crm){
			let budget = crm.budget
			if(!budget){
				const budgetCreate = await createBudget({
					item_type: 'crm',
					item_id: crm.id
				})
				if(budgetCreate.code == 200){
					budget = budgetCreate.budget
				}
			}

			localStorage.setItem('last_working_budget', JSON.stringify(budget))

			this.$store.commit('budget/setBudgetModalId', budget.id)
			// this.$router.push({ name: 'BudgetDetail', query: { id: budget.id } })
		},
		canReplicate(conversation){
			const userInfo = this.userInfo(conversation)
			return userInfo && userInfo.name && userInfo.email
		},
		replicateContactModal(conversation){
			const userInfo = this.userInfo(conversation)
			const data = {
				user_name: userInfo.name,
				lastname: userInfo.lastname,
				second_lastname: userInfo.second_lastname,
				user_email: userInfo.email,
				user_phone: userInfo.phone,
				project_detail: conversation.project_info?.project_detail,
				address: conversation.project_info?.address?.address,
				coordinates: conversation.project_info?.address?.coordinates,
				project_type_id: conversation.project_info?.project_type?.id,
				disable_user: true
			}
			this.$store.commit('crm/setNewContactModalData', data)
			this.$store.commit('crm/setNewContactModal', true)
		},
		userInfo(conversation){
			if(conversation.user){
				const user = conversation.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						lastname: user.user.profile.lastname,
						second_lastname: user.user.profile.second_lastname,
						email: user.user.email,
						phone: user.user.profile.phone,
						account: true
					}
				}
				return {
					name: user.name,
					lastname: user.lastname,
					second_lastname: user.second_lastname,
					email: user.email,
					phone: user.phone,
				}
			}
			return null
		},
		deleteUser(user) {
			const index = this.users.indexOf(user);
			if (index > -1) {
				this.users.splice(index, 1);
			}
		},
		async archiveCrm(crm_id){
			await archiveCrmEntry({crm_id})
			this.getClientCRM()
		},
		startRemoveCrm(crm_id){
			const confirmation = confirm("¿Estás seguro que quieres eliminar el registro?")
			if(confirmation){
				this.removeCrm(crm_id)
			}
		},
		async removeCrm(crm_id){
			await deleteCrmEntry({crm_id})
			this.getClientCRM()
		},
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
</style>